const t = {
  name: "Play",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.201 10.3105C20.4408 11.0958 20.4408 12.9046 19.201 13.6898L7.06994 21.3728C5.7383 22.2162 3.99984 21.2594 3.99984 19.6832V4.3172C3.99984 2.74097 5.7383 1.78419 7.06994 2.62756L19.201 10.3105ZM5.99984 19.6832L18.1309 12.0002L5.99983 4.3172L5.99984 19.6832Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Play
};
